/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */
import type {
  CallbackSummaryList,
  CallbackTicket,
  CallbacksListParams,
  CallbacksSummaryRetrieveParams
} from '../../model';

import { customFetch } from '../../../liftApiMutator';

export type callbacksListResponse200 = {
  data: CallbackTicket[]
  status: 200
}

export type callbacksListResponseSuccess = (callbacksListResponse200) & {
  headers: Headers;
};
;

export type callbacksListResponse = (callbacksListResponseSuccess)

export const getCallbacksListUrl = (params?: CallbacksListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/callbacks/?${stringifiedParams}` : `/api/v1/callbacks/`
}

/**
 * The callbacks themselves, for the modal a cell opens.
 */
export const callbacksList = async (params?: CallbacksListParams, options?: RequestInit): Promise<callbacksListResponse> => {

  return customFetch<callbacksListResponse>(getCallbacksListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}


export type callbacksSummaryRetrieveResponse200 = {
  data: CallbackSummaryList
  status: 200
}

export type callbacksSummaryRetrieveResponseSuccess = (callbacksSummaryRetrieveResponse200) & {
  headers: Headers;
};
;

export type callbacksSummaryRetrieveResponse = (callbacksSummaryRetrieveResponseSuccess)

export const getCallbacksSummaryRetrieveUrl = (params?: CallbacksSummaryRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/callbacks/summary/?${stringifiedParams}` : `/api/v1/callbacks/summary/`
}

/**
 * One row per elevator, with a cell per month.
 */
export const callbacksSummaryRetrieve = async (params?: CallbacksSummaryRetrieveParams, options?: RequestInit): Promise<callbacksSummaryRetrieveResponse> => {

  return customFetch<callbacksSummaryRetrieveResponse>(getCallbacksSummaryRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}


